const longTextToggle = require('./long-text-toggle');
const domUtils = require('./domutils');

module.exports = (eltId, title) => {

  const flixElement = document.getElementById(eltId);

  if (flixElement) {
    const observer = new MutationObserver((mutationList, observerInst) => {

      if (checkIfProductPageContainsFlixmedia(flixElement, mutationList)) {
        addExpandableTabAroundFlixmediaContent(flixElement, eltId, title);
        flixElement.classList.remove('hidden');
        observerInst.disconnect();
      }
    });

    observer.observe(
      flixElement,
      {
        childList: true,
        subtree: true
      }
    );
  }
};

/*
 *   <div id="flix-inpage">
 *     <div id="flixinpage_SOME_ID_NUMBER">
 *       Returns true if this element is not empty and false otherwise
 *     </div>
 *   </div>
 */
function checkIfProductPageContainsFlixmedia(flixElement, mutationList) {
  return mutationList.length &&
    mutationList.filter(
      (mutation) => mutation.type === 'childList' && mutation.addedNodes.length > 0
    ).reduce(
      ((addedNodesArray, mutation) => addedNodesArray.concat(Array.from(mutation.addedNodes))), []
    ).some(
      (addedNode) => addedNode.parentNode !== flixElement
    );
}

function addExpandableTabAroundFlixmediaContent(flixElement, eltId, title) {
  const flixTabSectionElement = domUtils.parentsByClass(flixElement, 'tab-section');

  const flixTitleElt = domUtils.makeElt('h2', { className: 'section-title border-b' });
  flixTitleElt.textContent = title;

  domUtils.prepend(flixTabSectionElement, flixTitleElt);

  // Init long text toggle
  longTextToggle.initialise({
    selector: `#${eltId}`,
    className: 'long-text-hidden',
    maxHeight: 300
  });
}
